import styled, { css } from 'styled-components';
import { media } from 'src/config/breakpoints';

export const AboutUsInfoItemContainer = styled.div`
  display: flex;
  flex-direction: column;
  max-width: 7.25rem;
  width: 50%;

  &:nth-of-type(odd) {
    margin-right: 1.6875rem;
  }

  ${media.w.min.px576(css`
    &:not(:last-of-type) {
      margin-right: 1.6875rem;
    }
  `)}

  ${media.w.min.px768(css`
    max-width: 7.9375rem;
  `)}
`;
